import { fetchGETRequest } from "./services";

export interface ContractBalance {
  contractId: string;
  contractNumber: string;
  currentBalance: number;
  lastUpdated: string;
}

export interface CustomerBalanceData {
  customerId: string;
  customerCode: string;
  customerName: string;
  totalBalance: number;
  contractBalances: ContractBalance[];
}

export interface ContractThresholdData {
  contractId: string;
  thresholdReached: boolean;
}

export const getCustomerBalance = async (
  customerId: string,
): Promise<CustomerBalanceData | null> => {
  try {
    // 1. Try direct call first
    try {
      const response = await fetchGETRequest<any>(
        `v2/Balances/customer/${customerId}`,
      );
      if (response?.success && response?.data) {
        return response.data;
      }
    } catch (e) {
      console.log(
        `Direct balance check failed for ${customerId}, trying fallback...`,
      );
    }

    // 2. Fallback: Search for the correct ID in the Customers list
    // We check against id, refId, and customerCode
    const customersResponse = await fetchGETRequest<any>("v2/Customers");
    if (customersResponse?.success && Array.isArray(customersResponse?.data)) {
      const customer = customersResponse.data.find(
        (c: any) =>
          c.id === customerId ||
          c.refId === customerId ||
          c.customerCode === customerId,
      );

      if (customer) {
        // If we found a match (even if it's the same ID, maybe the first call just failed temporarily)
        // or if it's a different ID (mapping refId/code to ID), try fetching balance with customer.id
        console.log(`Found customer mapping: ${customerId} -> ${customer.id}`);
        const finalResponse = await fetchGETRequest<any>(
          `v2/Balances/customer/${customer.id}`,
        );
        if (finalResponse?.success && finalResponse?.data) {
          return finalResponse.data;
        }
      }
    }

    return null;
  } catch (error) {
    console.error("Error in getCustomerBalance service:", error);
    return null;
  }
};

export const checkContractThreshold = async (
  contractId: string,
): Promise<ContractThresholdData | null> => {
  try {
    const response = await fetchGETRequest<any>(
      `v2/Balances/contract/${contractId}/check-threshold`,
    );
    if (response?.success && response?.data) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error(
      `Error checking threshold for contract ${contractId}:`,
      error,
    );
    return null;
  }
};
